angular.module("vgresiduos").controller("ResidueTraceabilityReportCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, "bi/relatorios/relatorio-rastreabilidade-residuos");
		};
	}
]);
